import React from 'react'
import './style.scss'

// Reference: https://stackoverflow.com/questions/7944460/detect-safari-browser
const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

function SafariSafe({ children }) {
  if (isSafari()) {
    return (
      <p className='safari_warning'>
        Ihr Browser unterstützt diese Seite nicht, bitte versuchen Sie einen anderen Browser
      </p>
    )
  } else {
    return children
  }
}

export default SafariSafe
